
import React from 'react';
import { Text4, Text5 } from '../../../styles';
import { Badge, Button, Icon } from 'antd';
import { BANK_ACCOUNT_VERIFICATION_STATUS } from '../../../constants';
import { PermissionHoc } from "../../HOC";

const PermissableButton = PermissionHoc(Button, "WIRE_FUNDING_ACCOUNT_WRITE", { is_component: true, fallbackComponent: null })

export const getBankAccountsTableColumns = (methods) => [{
        title: "Account Number",
        key: "account_number",
        render: (record) => <Text4 className="d-block">{record.account_number}</Text4>
    }, {
        title: "Bank IFSC",
        key: "account_ifsc",
        render: (record) => <Text4>{record.account_ifsc}</Text4>
    },{
        title: "Bank Name",
        key: "bank_name",
        render: (record) => <Text4>{record.bank_name}</Text4>
    },{
        title: "Bank Branch",
        key: "bank_branch",
        render: (record) =><Text4>{record.bank_branch}</Text4>
    },{
        title: "Name On Bank",
        key: "name_on_bank",
        render: (record) => <Text4>{record.name_on_bank}</Text4>
    },{
        title: "Status",
        key: "status",
        render: (record) => <Badge color={BANK_ACCOUNT_VERIFICATION_STATUS[record.status]?.color} text={BANK_ACCOUNT_VERIFICATION_STATUS[record.status]?.label} />
    },{
        title: "Action",
        render: (record) =><>
            <PermissableButton className="mr-1" size="small" onClick={() => methods.toggleBankAccountModal({ ...record, is_edit: true })} disabled={record.is_verified?true:false}>Edit</PermissableButton>
        </>
    },
];